import { useFieldHelper } from 'framework/ui/field';
import CardUserStatusField from '../../../availabilityUser/shared/field/CardUserStatusField';
import InterruptionCreatorButton from './layout/InterruptionCreatorButton';
import InterruptionCreatorName from './layout/InterruptionCreatorName';
import InterruptionCreatorRoot from './layout/InterruptionCreatorRoot';
import InterruptionCreatorStatus from './layout/InterruptionCreatorStatus';

type InterruptionCreatorFieldProps = {
  chatLinkSource?: string;
  chatLinkValue?: string;
  creatorIdSource?: string;
  creatorIdValue?: string;
  creatorNameSource?: string;
  creatorNameValue?: string;
  onOpenChat: (url: string) => void;
};

const InterruptionCreatorField = ({
  chatLinkSource = 'chatLink',
  chatLinkValue,
  creatorIdSource = 'creatorId',
  creatorIdValue,
  creatorNameSource = 'creatorName',
  creatorNameValue,
  onOpenChat,
}: InterruptionCreatorFieldProps) => {
  const { getValue: getChatLink } = useFieldHelper<string>({ value: chatLinkValue, source: chatLinkSource });
  const { getValue: getCreatorId } = useFieldHelper<string>({ value: creatorIdValue, source: creatorIdSource });
  const { getValue: getCreatorName } = useFieldHelper<string>({
    value: creatorNameValue,
    source: creatorNameSource,
  });
  const chatLink = getChatLink();
  const creatorId = getCreatorId();
  const creatorName = getCreatorName();

  return (
    <InterruptionCreatorRoot>
      <InterruptionCreatorButton onClick={() => onOpenChat(chatLink)} title={creatorName}>
        <InterruptionCreatorName>{creatorName}</InterruptionCreatorName>
      </InterruptionCreatorButton>

      <InterruptionCreatorStatus>
        <CardUserStatusField employeeId={creatorId} />
      </InterruptionCreatorStatus>
    </InterruptionCreatorRoot>
  );
};

export default InterruptionCreatorField;
